import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Psc } from './psc.model';

const axios = useAxios();

export interface PscService {
  Fetch: (dateFrom: Date, dateTo: Date) => Promise<AxiosResponse<Psc>>;
}

const Fetch = (dateFrom: Date, dateTo: Date): Promise<AxiosResponse<Psc>> => {
  const from = dateFrom.toISOString().split('T')[0];
  const to = dateTo.toISOString().split('T')[0];

  return axios.Get<Psc>(`/api/psc1111/from/${from}/to/${to}`);
};

export default { Fetch } as PscService;
